import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import View from '@loggi/ui/components/view';
import Col from '@loggi/ui/components/col';
import Button from '@loggi/ui/components/button';
import CheckboxButton from '@loggi/ui/components/checkbox-button';
import CheckboxGroup from '@loggi/ui/components/checkbox-group';
import {
  CONTESTATION_ACCEPTANCE,
  CONTESTATION_ACCEPTANCE_BUTTON_TEXT,
  BUTTON_REPLY_LATER,
  TEST_BUTTON_ID
} from './start-contest.constants';

export default class StartContestButton extends Component {
  constructor(props) {
    super(props);
    const { isChecked } = this.props;
    this.state = {
      isChecked
    };
  }

  _onClickGoToTracker = () => {
    const { history, statusPath } = this.props;
    history.replace(statusPath);
  };

  _toggleChange = () => {
    const { isChecked } = this.state;
    this.setState({
      isChecked: !isChecked
    });
  };

  render() {
    // isChecked turn button able only if the checkbox was checked
    const { isChecked } = this.state;

    const { onClickToAccept, isDisabled } = this.props;

    return (
      <View
        flex
        flexDirection="column"
        alignItems="center"
        gutter={{
          top: 'normal',
          bottom: 'normal',
          left: 'double',
          right: 'double'
        }}
      >
        <Col alignSelf="start">
          <CheckboxGroup
            name="agreeOption"
            onChange={this._toggleChange}
            selectedValue={isChecked ? ['agree'] : []}
          >
            <CheckboxButton
              labelChangeColor
              value="agree"
              label={CONTESTATION_ACCEPTANCE}
            />
          </CheckboxGroup>
        </Col>
        <Col
          flex
          flexDirection="column"
          gutter={{
            bottom: 'normal',
            left: 'double',
            right: 'double'
          }}
        >
          <Button
            data-testid={TEST_BUTTON_ID}
            shape={ROUNDED_SHAPE}
            style="outline"
            value={CONTESTATION_ACCEPTANCE_BUTTON_TEXT}
            onClick={onClickToAccept}
            disabled={!isChecked || isDisabled}
          />
        </Col>
        <Col
          flex
          flexDirection="column"
          gutter={{
            bottom: 'normal',
            left: 'double',
            right: 'double'
          }}
        >
          <Button
            shape={ROUNDED_SHAPE}
            style="outline"
            value={BUTTON_REPLY_LATER}
            onClick={this._onClickGoToTracker}
          />
        </Col>
      </View>
    );
  }
}

StartContestButton.displayName = 'StartContestButton ';
StartContestButton.propTypes = {
  onClickToAccept: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  statusPath: PropTypes.string.isRequired
};

StartContestButton.defaultProps = {
  isChecked: false
};
